import type { TypographyProps } from './Typography.types';

import { S } from './Typography.styles';

export const Typography = ({ variant, children, color, ...props }: TypographyProps) => {
  const elementMap = {
    // Display & Headlines
    displayAndHeadlineXtraLarge: 'h1',
    displayAndHeadlineLarge: 'h1',
    displayAndHeadlineMedium: 'h1',
    displayAndHeadlineSmall: 'h2',
    displayAndHeadlineXtraSmall: 'h2',
    displayAndHeadline2XtraSmallMedium: 'h2',

    // Section Headers
    sectionHeaderMedium: 'h2',

    // Subsection Headers
    subsectionHeaderMedium: 'h3',
    subsectionHeaderRegular: 'h3',
    subsectionHeaderDense: 'h3',
    subsectionHeaderSmallMedium: 'h3',

    // Subheaders
    subheaderLargeMedium: 'h4',
    subheaderMediumMedium: 'h4',
    subheaderSmallMedium: 'h4',

    // Body text
    bodyLargeRegular: 'p',
    bodyLargeMedium: 'p',
    bodyMediumBaseRegular: 'p',
    bodyMediumBaseMedium: 'p',
    bodySmallRegular: 'p',
    bodySmallMedium: 'p',
    bodySmallMediumTabular: 'p',
    bodyExtraSmallRegular: 'p',
    bodyExtraSmallMedium: 'p',

    // Intro Lead
    introLeadLargeRegular: 'p',
    introLeadMediumRegular: 'p',
    introLeadSmallRegular: 'p',

    // Callouts
    calloutLargeMedium: 'p',
    calloutMediumMedium: 'p',
    calloutSmallMedium: 'p',
    calloutExtraSmallMedium: 'p',
    callout2XtraSmallMedium: 'p',
    callout3XtraSmallMedium: 'p',

    // Overlines
    overlineLargeRegular: 'p',
    overlineLargeDenseRegular: 'p',
    overlineMediumRegular: 'p',
    overlineSmallRegular: 'p',

    // Labels
    labelLargeRegular: 'label',
    labelLargeMedium: 'label',
    labelMediumRegular: 'label',
    labelMediumMedium: 'label',
    labelMediumRegularDense: 'label',
    labelMediumMediumDense: 'label',
    labelSmallRegular: 'label',
    labelSmallMedium: 'label',
    labelSmallNeg1Regular: 'label',
    labelXtraSmallRegular: 'label',
    labelXtraSmallMedium: 'label',
    label2XtraSmallRegular: 'label',
    label2XtraSmallMedium: 'label',

    // Captions
    captionRegular: 'span',
    captionMedium: 'span',

    // Tooltips
    tooltipRegular: 'span',
    tooltipMedium: 'span',

    // Microtext
    microTextRegular: 'span',
    microTextMedium: 'span'
  } as const;

  return (
    <S.Typography as={elementMap[variant]} variant={variant} $color={color as any} {...props}>
      {children}
    </S.Typography>
  );
};
